var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 6.666,
  r: 2.583,
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeWidth: 1.5,
  d: "M12.651 6.625a1.75 1.75 0 1 1 3.031 1.75 1.75 1.75 0 0 1-3.03-1.75ZM4.318 6.625a1.75 1.75 0 1 1 3.03 1.75 1.75 1.75 0 0 1-3.03-1.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#49475A",
  d: "m14.055 15-.75.027.026.723h.724zm3.146-1.09.697-.275zm-4.884-1.65-.453-.598-.868.659.925.575zm1.717 2.585-.73.169zm2.333-.595h-2.312v1.5h2.312zm.136-.063c.007.017.004.019.005.01.001-.006.003-.005-.003.002-.013.016-.057.051-.138.051v1.5c.52 0 1.004-.23 1.313-.618.318-.4.433-.954.218-1.497zm-2.336-1.77c1.343 0 1.997.912 2.336 1.77l1.395-.552c-.43-1.087-1.472-2.718-3.731-2.718zm-1.396.44c.335-.255.779-.44 1.396-.44v-1.5c-.95 0-1.712.296-2.303.745zm-.85.039c.838.521 1.217 1.402 1.383 2.118l1.461-.339c-.207-.892-.727-2.229-2.052-3.053zm1.383 2.118.002.013 1.499-.053q-.006-.15-.04-.299zM7.683 12.259l.396.637.925-.576-.868-.658zM2.799 13.91l.698.276zM5.945 15v.75h.724l.025-.725zm.02-.156-.73-.17zm-.132-2.428c.617 0 1.061.185 1.396.44l.907-1.195c-.591-.45-1.353-.745-2.303-.745zm-2.336 1.77c.34-.858.993-1.77 2.336-1.77v-1.5c-2.259 0-3.3 1.63-3.731 2.717zm.136.063c-.081 0-.125-.035-.138-.052-.006-.007-.004-.007-.003-.001.001.008-.002.007.005-.01l-1.395-.553c-.215.544-.1 1.097.218 1.498.309.388.792.618 1.313.618zm2.312 0H3.633v1.5h2.312zm.75.776.001-.012-1.461-.339a1.6 1.6 0 0 0-.04.299zm.001-.012c.166-.717.545-1.597 1.383-2.118l-.792-1.274c-1.325.824-1.845 2.16-2.052 3.053z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M10 11.667c2.847 0 3.749 1.946 4.034 3.178.125.538-.315.989-.867.989H6.833c-.552 0-.992-.451-.867-.99.285-1.231 1.187-3.177 4.034-3.177Z"
})));
export { SvgUserIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/user-icon.svg";